export default "__VITE_ASSET__DO9Umcm0__"